// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"189":"editor","328":"admin","340":"overview","747":"wiki","985":"email_verified"}[chunkId] || chunkId) + "." + {"189":"ca145250","225":"07c094f6","269":"fad2cff2","328":"06209459","340":"3332f8d6","723":"74e4b9b3","747":"1e8a33ce","786":"82354a53","887":"0cdf69f4","985":"89f95dc8"}[chunkId] + ".js";
};